module.exports = __webpack_public_path__ + "static/media/02.adobe-photoshop.53330347.svg";